module.exports = __webpack_public_path__ + "img/sagepay_logo.f5552859.jpg";